import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DeleteContainer = styled.div`
  display: flex;
  justify-content: space-between;
  & > div:last-child {
    align-self: flex-start;
    cursor: pointer;
  }
`;

export const ModalContent = styled.div`
  & > div:first-child {
    width: 99%;
  }
  & > div:last-child > div:first-child {
    .ant-btn-primary {
      background: ${({ theme }) => theme.colors.tone.yellow};
      border-color: ${({ theme }) => theme.colors.tone.yellow};
    }
  }
`;
